import * as React from "react";
import { Timer, ClipboardCheck, MapPin, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const features = [{
  title: "Rapid Response Speed",
  description: "Water damage spreads fast — the sooner you call, the less it costs to fix. We connect you with local Pueblo restoration professionals who are on standby 24/7 and ready to move.",
  icon: Timer,
  iconColor: "text-chart-3",
  link: "/ServicesPage"
}, {
  title: "Technical Experience",
  description: "The certified professionals in our network use advanced structural drying techniques and industrial‑grade equipment to get your property fully restored.",
  icon: ClipboardCheck,
  iconColor: "text-chart-1",
  link: "/ServicesPage"
}, {
  title: "Local Pueblo Knowledge",
  description: "Deeply rooted in Pueblo, CO. We understand local building codes and environmental factors across Pueblo West, Canon City, and Florence.",
  icon: MapPin,
  iconColor: "text-chart-2",
  link: "/ServicesPage"
}];
export default function TheJunkDaddyDifference() {
  return <section data-section-id="225002" id="the-pueblo-speed-advantage" className="bg-background text-foreground py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="font-default text-3xl font-black tracking-tighter text-primary md:text-4xl lg:text-6xl uppercase">
            The Pueblo Speed Advantage
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg font-default text-muted-foreground">
            We bring a new level of urgency to water damage restoration. Here is why your neighbors trust us with their homes and businesses during emergencies.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {features.map((feature, i) => <div data-index={i} key={i} className="group relative h-full">
              <Link to={feature.link} className="absolute inset-0 z-10">
                <span className="sr-only">Learn more about {feature.title}</span>
              </Link>
              <Card className="flex h-full flex-col justify-between rounded-md border border-border bg-card shadow-md transition-all duration-200 group-hover:-translate-y-1 group-hover:border-chart-3 group-hover:shadow-lg">
                <div>
                  <CardHeader className="pb-4">
                    <feature.icon className={`mb-4 size-16 stroke-[2] ${feature.iconColor}`} aria-hidden="true" />
                    <CardTitle className="font-default text-2xl font-bold text-primary">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base font-default text-muted-foreground">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </div>
                <div className="px-6 pb-6">
                  <div className="flex items-center text-sm font-bold text-chart-3 opacity-0 transition-all duration-200 group-hover:translate-x-2 group-hover:opacity-100">
                    View Restoration Process <ArrowRight className="ml-2 size-4 stroke-[3]" />
                  </div>
                  <div className="mt-4 h-1.5 w-full bg-muted overflow-hidden rounded-md">
                    <div className="h-full w-full bg-chart-3 transition-all duration-500" />
                  </div>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}